<template>
  <div class="out-wrap">
    <Loadding ref="load" class="load-wrap" :submitInfo="`提交核验中...`" />
    <div class="img-wrap">
      <img src="https://img-fe.seersecret.com/image/2522fba0bb8939b8ebcd35451c3482f3-800x874.png" alt="" />
    </div>
    <h5>面试评估表</h5>
    <div v-if="isPass" class="input-wrap">
      <van-field class="input" clearable left-icon="contact" v-model="name" label="姓名" placeholder="请输入姓名" />
      <!-- <van-field
        class="input"
        clearable
        left-icon="comment-circle-o"
        v-model="word"
        label="英文名"
        placeholder="请输入英文名"
      /> -->
      <van-button
        :disabled="name == ''"
        square
        class="submit-btn"
        color="#3040F5"
        style="margin-top: 10px;"
        @click="checkPeople"
        >核验</van-button
      >
    </div>
    <div class="btn-wrap" v-if="!isPass">
      <van-button icon="eye-o" round type="info" @click="toEvaluation('watch')">查看评估表</van-button>
      <van-button icon="edit" round type="primary" @click="toEvaluation('edit')">编辑评估表</van-button>
    </div>
  </div>
</template>

<script>
import { request } from '../../utils/request';
import API from '../../utils/API';
import { setStore } from '../../utils/localStore';
import Loadding from '../other/comp/load';
export default {
  name: 'interviewEvaluation',
  data() {
    return {
      name: '',
      word: '',
      isPass: true,
    };
  },
  components: {
    Loadding,
  },
  methods: {
    toEvaluation(type) {
      this.$router.push({
        path: '/evaluation',
        query: {
          type,
          id: this.$route.query.id,
        },
      });
    },
    checkPeople() {
      let id = this.$route.query.id;
      if (!id) {
        this.$toast.fail('缺少面试id！');
        return;
      }
      let info = {
        name: this.name,
        id,
      };
      this.$refs.load.openLoad();
      request({
        method: 'get',
        url: API.CHECK_STAFF_INFO,
        data: info,
      })
        .then((res) => {
          this.$refs.load.closeLoad();
          let data = res.data;
          if (typeof data == 'string') {
            this.$toast({
              duration: 3000,
              message: data,
            });
            return;
          }
          if (data.status == 'fail') {
            this.$toast({
              duration: 3000,
              message: data.message,
            });
            return;
          } else {
            setStore({
              name: 'evaluationUserInfo',
              content: Object.assign({}, info, {
                staff_id: data.data.staff_id,
                name: data.data.name,
                word: data.data.title,
              }),
              options: {
                expiry: '5h',
              },
            });
            this.toEvaluation('watch');
          }
        })
        .catch((err) => {
          this.$refs.load.closeLoad();
          this.$toast.fail('系统错误');
        });
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/page.css';
@import '../../assets/css/wrap.css';
.btn-wrap {
  margin-top: 80px;
  display: flex;
  justify-content: space-around;
}
.img-wrap {
  margin-top: 40px;
  margin-bottom: 20px;
  text-align: center;
  img {
    width: 180px;
  }
}
</style>
